<template>
  <div>

    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('respond') }} {{ $t('supportticketing') }}</div>
      <router-link
        class="btn-blue"
        to="/cinema-manager/support-ticketing"
      >{{ $t('supportticketing') }} {{ $tc('list', 2) }}</router-link>
    </div>

    <div class="white-wrapper">
      <div class="d-flex mb-3">
        <div v-if="TicketListByID_IsFirst.length > 0" class="pl-2">
          <h3 class="mb-0">{{ TicketListByID_IsFirst[0].stm_subject }}</h3>
          <small>{{ TicketListByID_IsFirst[0].created_at | fulldatemonparse }}</small>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4 col-xl-2 mb-4">
          <div class="input-material">
            <label>Created By :- {{ selecteduser }}</label>
          </div>
        </div>

        <div class="col-lg-4 col-xl-4 align-self-center mb-4">
          <div class="input-material">
            <!-- <input placeholder="." disabled /> -->
            <label>Support Ticket Category :- {{ selectedcategory }}</label>
          </div>
        </div>

        <div class="col-lg-12 col-xl-12 mb-4">
          <div
            class="column"
            v-if="TicketListByID_IsFirst && TicketListByID_IsFirst[0].UploadedImages.length > 0"
            v-for="(images, imagesIndex) in TicketListByID_IsFirst[0].UploadedImages"
            :key="imagesIndex"
          >
            <img :src="_GetImagePath(images)" alt />
          </div>
        </div>

        <div class="col-lg-12 col-xl-12 mb-4">
          <div class="d-flex">
            <div class="input-material-textarea">
              <textarea
                :disabled="statusenable"
                v-model="ticket_description"
                rows="5"
                v-validate="'required'"
                type="text"
                placeholder="Description"
                name="description"
                id="description"
                class="rounded-10"
              ></textarea>
              <label
                :class="ticket_description && ticket_description.length > 0 ? 'shift-up' : '' "
              >{{ $t('description') }}</label>
            </div>
          </div>
          <p v-if="submitted && errors.has('description')" class="error_message">
            <span>{{ errors.first("description")}}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t('active') }}</label>
            <b-form-checkbox
              v-model="st_is_active"
              :disabled="statusenable"
              name="check-button"
              switch
            ></b-form-checkbox>
          </div>
        </div>

        <div class="col-md-12 text-center">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit('Open')"
            class="btn-blue"
          >Submit as Open</button>
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit('Close')"
            class="btn-blue"
          >Submit as Close</button>

          <b-button
            class="btn-outline-grey"
            variant="default"
            to="/cinema-manager/support-ticketing"
          >{{ $t('cancel') }}</b-button>
        </div>
      </div>

      <div v-if="TicketListByID_IsFirst.length > 0" class="pt-2 border-bottom pb-3">
        <div class="d-flex">
          <img src="@/assets/img/icons/user-male.svg" height="28" width="28" />
          <div class="pl-2 w-100">
            <h5
              class="mb-0"
            >{{ TicketListByID_IsFirst[0].first_name }} {{ TicketListByID_IsFirst[0].middle_name }} {{ TicketListByID_IsFirst[0].last_name }} {{TicketListByID_IsFirst[0].st_creator_customer_email }}</h5>
            <small>{{ TicketListByID_IsFirst[0].created_at | fulldatemonparse }}</small>
            <div class="msg-box p-2">
              <p>{{ TicketListByID_IsFirst[0].stm_comment }}</p>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="TicketListByID_SubMsgs.length > 0"
        v-for="(submsg, submsgIndex) in TicketListByID_SubMsgs"
        :key="submsgIndex"
        class="pl-5 py-4 border-bottom"
      >
        <div class="d-flex">
          <img src="@/assets/img/icons/user-male.svg" height="28" width="28" />
          <div class="pl-2 w-100">
            <h3 class="mb-0">{{ submsg.fullName || TicketListByID_IsFirst[0].st_creator_customer_email }}</h3>
            <small>{{ submsg.stm_created_at | fulldatemonparse }}</small>
            <div class="msg-box p-2">
              <p>{{ submsg.stm_comment }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import CinemasService from "@/services/CinemasService";
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      btenable: false,
      isRoleID: true,
      submitted: false,
      isUserID: true,
      Cinemas: [],
      status: null,
      statusenable: true,

      cine_id: null,
      selectedcinema: "",
      user_id: null,
      selecteduser: "",
      category_id: null,
      selectedcategory: "",
      ticket_subject: "",
      ticket_description: "",
      st_is_active: true,
      TicketCategoryList: [],
      Users: [],
      stID: null,
      TicketListByID_IsFirst: [],
      TicketListByID_SubMsgs: []
    };
  },
  beforeMount() {
    this.stID = this.$route.query.id;
    this.status = this.$route.query.status;
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    this.user_id = this.secureStore.get("USINFO").user_id;

    this.selecteduser =
      this.secureStore.get("USINFO").first_name +
        " " +
        this.secureStore.get("USINFO").middle_name &&
      this.secureStore.get("USINFO").middle_name != null
        ? this.secureStore.get("USINFO").middle_name
        : this.secureStore.get("USINFO").first_name +
          " " +
          this.secureStore.get("USINFO").last_name;

    if (true) {
      this.isRoleID = false;
    }

    if (this.status == "Unresolved") {
      this.statusenable = false;
      this.btenable = false;
    } else {
      this.statusenable = true;
      this.btenable = true;
    }

    if (this.user_id == 1) {
      this.isUserID = false;
    }
    this.getCinemasList(obj);
    this.getUsersList(obj, this.user_id);
    this.GetAllTicketsByID();
  },
  methods: {
    GetAllTicketsByID: function() {
      let payload = {
        st_id: this.stID
      };
      let loader = this.$loading.show();

      CinemasService.GetTickets(payload)
        .then(response => {
          const { data } = response;

          if (data.status) {
            if (data.Records && data.Records.length > 0) {
              let Obj = data.Records;

              Obj.map(x => {
                if (x.stm_is_first == "Y") {
                  this.TicketListByID_IsFirst.push(x);
                  this.GetSupportTicketCategory(x.stc_id);
                }
              });

              let Obj2 = data.Records2;

              Obj2.map(x => {
                x.fullName = `${x.first_name ? x.first_name : ''}${x.middle_name ? ` ${x.middle_name}` : ''}${x.last_name ? ` ${x.last_name}` : ''}`

                if (x.stm_is_first == "N") {
                  this.TicketListByID_SubMsgs.push(x);
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },
    getCinemasList: function(cine_id) {
      this.Cinemas = [];
      // let payload = {
      //   tableName: "ms_cinemas",
      //   cine_is_active: "Y"
      // };
      MasterService.GetCinemas({cine_id: cine_id})
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                this.selectedcinema = x.cine_name;
                this.cine_id = x.cine_id;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    getUsersList: function(cinema_id, user_id) {
      let body = this.getRequestBody("GET", undefined, {
        GET: "/admin/",
        tableName: "users"
      });
      if (cinema_id) {
        body[cinema_id] = cinema_id;
      }
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Users = data.Records;

            this.Users.map(x => {
              if (String(user_id) === String(x.user_id)) {
                this.selecteduser =
                  x.first_name + " " + x.middle_name + " " + x.last_name;
                this.user_id = x.user_id;
              }
            });
          } else {
          }
        })
        .catch(this._CatchError);
    },

    GetSupportTicketCategory: function(id) {
      let payload = {
        limit: null,
        currentPage: null
      };

      MasterService.GetCategory(payload)
        .then(response => {
          const { data } = response;

          if (data.status) {
            if (data.Records && data.Records.length > 0) {
              this.TicketCategoryList = data.Records;

              this.TicketCategoryList.map(x => {
                if (id == x.stc_id) {
                  this.selectedcategory = x.stc_name;
                  this.category_id = x.stc_id;
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    OnSelect: function(type, event, data) {
      if (type == "cinema") {
        this.selectedcinema = data.cine_name;
        this.cine_id = data.cine_id;
      }
      if (type == "user") {
        this.selecteduser =
          data.first_name + " " + data.middle_name + " " + data.last_name;
        this.user_id = data.user_id;
      }
      if (type == "category") {
        this.selectedcategory = data.stc_name;
        this.category_id = data.stc_id;
      }
    },

    onResetForm: function() {
      this.category_id = null;
      this.ticket_subject = "";
      this.ticket_description = "";
      this.selectedcategory = null;
      this.cine_id = null;
      this.selectedcinema = null;
      // this.user_id = null;
      // this.selecteduser = null;
    },

    OnFinalSubmit: function(flag) {
      this.submitted = true;

      if (this.selecteduser.length == 0) {
        return;
      }
      if (this.selecteduser == null) {
        return;
      } else {
        this.$validator.validate().then(valid => {
          if (valid) {
            this.btenable = true;
            let payload = {
              st_id: this.stID,
              res_user_id: this.user_id,
              ticket_status: flag,
              description: this.ticket_description,
              category_id: this.category_id,
              is_active: this.st_is_active
            };

            CinemasService.RespondSupportTicket(payload)
              .then(response => {
                this.btenable = false;
                const { data } = response;

                if (data.status) {
                  this.$toasted.show(data.message);

                  this.$router.push({
                    path: "/cinema-manager/support-ticketing"
                  });
                } else {
                  this.btenable = false;
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError);
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.msg-box {
  background-color: #e9ecef;
}
img {
  max-width: 50%;
  height: auto;
}
* {
  box-sizing: border-box;
}

.column {
  float: left;
  width: 33.33%;
  padding: 5px;
}

/* Clearfix (clear floats) */
.row::after {
  content: "";
  clear: both;
  display: table;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/SupportTicketingComponents/editSupportTicketing.vue